import React, { useState } from 'react';
import { Box, Typography, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, Paper, Collapse, IconButton } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { formatTimestamp } from '../../domain/meetingResult';

/**
 * Authenticated, collapsed-by-default speaker diagnostics.
 */
const SpeakerDiagnostics = ({ diagnostics, anchors }) => {
  const [open, setOpen] = useState(false);

  if (!diagnostics || diagnostics.length === 0) return null;

  const anchorByName = new Map(
    (anchors || [])
      .filter((a) => a && a.displayName)
      .map((a) => [a.displayName, a])
  );

  const rows = diagnostics.map((diag) => {
    const anchor = diag.speakerName ? anchorByName.get(diag.speakerName) : null;
    return { ...diag, anchor };
  });

  return (
    <Card data-testid="speaker-diagnostics">
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Speaker Diagnostics</Typography>
          <IconButton size="small" onClick={() => setOpen((v) => !v)} aria-label={open ? 'Collapse diagnostics' : 'Expand diagnostics'}>
            {open ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </Box>

        <Collapse in={open}>
          <TableContainer component={Paper} variant="outlined" sx={{ mt: 1 }}>
            <Table size="small" aria-label="speaker diagnostics">
              <TableHead>
                <TableRow>
                  <TableCell>Speaker</TableCell>
                  <TableCell align="right">Turns</TableCell>
                  <TableCell align="right">Talk time</TableCell>
                  <TableCell align="right">Talk ratio</TableCell>
                  <TableCell align="right">Identity match</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.speakerId || row.speakerName || 'unknown'}>
                    <TableCell>{row.speakerName || 'Unknown speaker'}</TableCell>
                    <TableCell align="right">{row.turnCount ?? '—'}</TableCell>
                    <TableCell align="right">{formatTimestamp(row.totalSeconds)}</TableCell>
                    <TableCell align="right">
                      {row.talkRatio != null ? `${Math.round(row.talkRatio * 100)}%` : '—'}
                    </TableCell>
                    <TableCell align="right">
                      {row.anchor?.identitySimilarity != null ? (
                        <Chip
                          size="small"
                          label={`${Math.round(row.anchor.identitySimilarity * 100)}%`}
                          color={row.anchor.identitySimilarity >= 0.8 ? 'success' : row.anchor.identitySimilarity >= 0.5 ? 'warning' : 'default'}
                          variant="outlined"
                        />
                      ) : (
                        '—'
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Collapse>
      </CardContent>
    </Card>
  );
};

export default SpeakerDiagnostics;